import type { AppProps } from "next/app";
import "../src/styles/globals.scss";
import '@/src/styles/timepicker.css';
import { Toaster } from "@/src/components/ui/toaster";
import { SessionProvider } from "next-auth/react";
import GlobalProvider from "../src/components/layouts/GlobalProvider";
import AdSense from "@/src/components/layouts/adSense";
import Head from "next/head"; // ✅ Use this instead

export default function App({ Component, pageProps }: AppProps) {
  const PID = process.env.NEXT_PUBLIC_GA_ID || "";

  
  return (
    <>

      {/* Load Google Tag Manager script after page interaction */}
      <AdSense pid={PID} />

      <GlobalProvider>
        <Component {...pageProps} />
        <Toaster />
      </GlobalProvider>
    </>
  );
}
